import { createEvent } from 'effector'

/** Clears cached TvShows genres and languages when preferred region changes. */
export const resetTvshowsOnPreferredRegionChange = createEvent()
